import { render } from "./HeaderComponent.vue?vue&type=template&id=07021a99&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=07021a99&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07021a99"

export default script